import React, { useEffect, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link } from "react-router-dom";
import { errorMessage } from "../../../utils/alertMessage";
import { getJobs } from "../../../services/JobMasterJobs";
import { InputText } from "primereact/inputtext";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import { formatDate } from "../../../constants/FormateDate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function JobList() {
  const [products, setProducts] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState(null);

  const fetchData = () => {
    getJobs()
      .then((response) => {
        if (!response.data.error) {
          setProducts(
            response.data.sort((a, b) =>
              a.name.trim().localeCompare(b.name.trim())
            )
          );
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      });
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearchInputChange = (event) => {
    const searchQueryValue = event.target.value;
    const filteredProducts = products.filter((p) =>
      p.name.toLowerCase().includes(searchQueryValue.toLowerCase())
    );
    setFilteredProducts(filteredProducts);
    setSearchQuery(searchQueryValue);
  };

  return (
    <main id="main" className="main">
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Task List</h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <InputText
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />

                  <div className="col-md-2" style={{ alignSelf: "center" }}>
                    <Link
                      to="/job-master/jobs/create"
                      className="move-btn move-btn-su center-text"
                    >
                      Create
                    </Link>
                  </div>
                </div>
                {/*<div className="dataview-demo">
                  <div className="card">
                    <DataView
                      value={filteredProducts || products}
                      layout={layout}
                      header={header}
                      itemTemplate={itemTemplate}
                      paginator
                      rows={9}
                    />
                  </div>
                </div>*/}
                <DataTable
                  value={filteredProducts || products}
                  paginator
                  paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  dataKey="id"
                  className="p-datatable-customers client-table-design"
                  resizableColumns
                  columnResizeMode="fit"
                >
                  <Column
                    field="name"
                    header="Title"
                    resizeable={false}
                    className="product-category table-design"
                  ></Column>
                  <Column
                    field="description"
                    header="Description"
                    className="product-category table-design"
                    body={(rowData) => (
                      <span >
                        {rowData.description}
                      </span>
                    )}
                  ></Column>
                  <Column
                    field="customerFileProcessJobDTOList[0].customerFileJob.mvnJob.name"
                    header="Time"
                    className="product-category table-design"
                    body={(rowData) => (
                      <span>
                        {rowData.jobDays ? (
                          <td
                            style={{
                              width: "10%",
                              fontSize: "13px",
                              fontWeight: 500,
                            }}
                          >
                            {rowData.jobDays} Days
                          </td>
                        ) : (
                          rowData.jobDate > "1970-01-01T00:00:00Z" && (
                            <td
                              style={{
                                width: "10%",
                                fontSize: "13px",
                                fontWeight: 500,
                              }}
                            >
                              {formatDate(rowData.jobDate)}
                            </td>
                          )
                        )}
                      </span>
                    )}
                  ></Column>
                  <Column
                    field="service"
                    header="Services"
                    className="product-category table-design"
                  ></Column>
                  <Column
                    field="frequency"
                    header="Frequency"
                    className="product-category table-design"
                  ></Column>
                  <Column
                    field="data.customerFileProcessJobDTOList[0].status"
                    header="Action"
                    className="product-category table-design"
                    body={(rowData) => (
                      <span>
                        {
                          <Link
                            to={"/job-master/jobs/edit"}
                            state={rowData}
                            className="move-btn-small move-btn-re center-text"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </Link>
                        }
                      </span>
                    )}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
